// extracted by mini-css-extract-plugin
export default {"container":"component_form_employee_container__tDC+Y","checkboxGroup":"component_form_employee_checkboxGroup__0YhN3"};